// BOOKING

export enum PROCESS_STEP {
	EVENT = 'event',
	PROMOTER = 'promoter',
	TECH = 'tech',
	TIMES = 'times',
	FEE = 'fee',
	ACOOMODATION = 'accomodation',
	SUMMARY = 'summary',
}

// it is used as a ID to better identify when exported - place to apply constraints
export enum DATA_SECTION {
	EVENT = PROCESS_STEP.EVENT,
	PROMOTER = PROCESS_STEP.PROMOTER,
	TECH = PROCESS_STEP.TECH,
	TIMES = PROCESS_STEP.TIMES,
	FEE = PROCESS_STEP.FEE,
	ACOOMODATION = PROCESS_STEP.ACOOMODATION,
	FILLED_BY = 'filled_by',
	SOUND = 'sound',
	TECH_CONTACT = 'tech_contact',
	CONTRACT = 'contract',
}

export const BOOKER_BASE = '/booker/';
export const BOOKING_BASE = '/booking/';

export const routes = {
	booking: {
		base: BOOKING_BASE + ':id/',
		event: BOOKING_BASE + ':id/' + PROCESS_STEP.EVENT,
		promoter: BOOKING_BASE + ':id/' + PROCESS_STEP.PROMOTER,
		times: BOOKING_BASE + ':id/' + PROCESS_STEP.TIMES,
		fee: BOOKING_BASE + ':id/' + PROCESS_STEP.FEE,
		accomodation: BOOKING_BASE + ':id/' + PROCESS_STEP.ACOOMODATION,
		summary: BOOKING_BASE + ':id/' + PROCESS_STEP.SUMMARY,
		nonexisting: BOOKING_BASE + 'non-existing',
	},
	booker: {
		request: BOOKER_BASE + 'requests/',
		requestCreate: BOOKER_BASE + 'requests/create/',
		requestEdit: BOOKER_BASE + 'requests/:id/',

		artist: BOOKER_BASE + 'artists/',
		artistCreate: BOOKER_BASE + 'artists/create/',
		artistEdit: BOOKER_BASE + 'artists/:id/',

		calendar: BOOKER_BASE + 'calendar/',

		account: BOOKER_BASE + 'account/',
		accountPassword: BOOKER_BASE + 'account/password/',
		accountOrganization: BOOKER_BASE + 'account/organization/',
	},
};

// TO REMOVE
export const ROUTE_AUTH = '/auth';
export const ROUTE_SIGN_IN = ROUTE_AUTH + '/sign-in';
export const ROUTE_SIGN_UP = ROUTE_AUTH + '/sign-up';
export const ROUTE_ACCOUNT_CREATED = ROUTE_AUTH + '/account-created';
export const ROUTE_ACCOUNT_CONFIRMATION = ROUTE_AUTH + '/account-confirmation';
export const ROUTE_FORGOT_PASSWORD = ROUTE_AUTH + '/forgot-password';
export const ROUTE_RESET_PASSWORD = ROUTE_AUTH + '/reset-password';

export const ROUTE_EXAMPLES = '/examples';
export const ROUTE_UIKIT = '/ui';
